module.exports = __webpack_public_path__ + "img/EST.96b78ed9.png";